<template>
  <b-modal
    id="modal-print-order"
    centered
    size="lg"
    title="入貨單詳情"
    hide-footer
    @hide="resetModal"
  >
    <div ref="printArea">
      <!-- 入貨單頭部信息 -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h3>入貨單</h3>
        <div><strong>單號:</strong> {{ orderData.po_number }}</div>
      </div>

      <div class="mb-3">
        <div class="row">
          <div class="col-6">
            <p>
              <strong>供應商:</strong>
              {{ orderData.supplier && orderData.supplier.name }}
            </p>
            <p>
              <strong>聯繫人:</strong>
              {{ orderData.supplier && orderData.supplier.contacts }}
            </p>
            <!--  <p>
              <strong>電話:</strong>
              {{ orderData.supplier && orderData.supplier.phone }}
            </p>
            <p>
              <strong>地址:</strong>
              {{ orderData.supplier && orderData.supplier.address }}
            </p> -->
          </div>
          <div class="col-6 text-right">
            <p><strong>日期:</strong> {{ orderData.order_date }}</p>
            <p><strong>備註:</strong> {{ orderData.remark || "無" }}</p>
          </div>
        </div>
      </div>

      <!-- 產品列表 -->
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>產品名稱</th>
              <th>型號</th>
              <th>數量</th>
              <th>單價</th>
              <th>總價</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in orderData.items" :key="item.id">
              <td>{{ item.product.name }}</td>
              <td>{{ item.product.model }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.unit_price }}</td>
              <td>{{ item.total_price }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4" class="text-right"><strong>總金額:</strong></td>
              <td colspan="2">{{ orderData.total_amount }}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- 簽名欄 -->
      <div class="row mt-4">
        <div class="col-6">
          <p>經手人: ________________</p>
        </div>
        <div class="col-6 text-right">
          <p>審核人: ________________</p>
        </div>
      </div>
    </div>

    <!-- 按鈕 -->
    <div class="text-center mt-3">
      <b-button variant="primary" @click="printOrder" class="mr-2">
        <feather-icon icon="PrinterIcon" class="mr-1" />
        打印
      </b-button>
      <b-button variant="outline-secondary" @click="hide"> 關閉 </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BButton } from "bootstrap-vue";
import { print } from "@/libs/print";

export default {
  components: {
    BModal,
    BButton,
  },

  props: {
    orderData: {
      type: Object,
      required: true,
    },
  },

  methods: {
    hide() {
      this.$bvModal.hide("modal-print-order");
    },

    resetModal() {
      this.$emit("modal-hidden");
    },

    printOrder() {
      print(this.$refs.printArea, {
        title: `入貨單_${this.orderData.po_number}`,
      });
    },
  },
};
</script>

<style scoped>
@media print {
  .modal {
    position: absolute;
    left: 0;
    top: 0;
    margin: 0;
    padding: 0;
    overflow: visible !important;
  }
}
</style>
